import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 32px;
  overflow-y: auto;
  ${customScrollMinimal};
  max-height: 33%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin: 0 auto;
  max-width: 475px;
  height: 243px;
`;

export const Img = styled.img`
  padding-bottom: 32px;
`;

export const Title = styled.h2`
  ${typographyV2.titleBase}
`;

export const Description = styled.p`
  text-align: center;
  ${typographyV2.bodySm}
  color: var(--text-soft);
`;
